<template>
    <el-card shadow="hover">
        <label slot="header">label样式的呈现组件</label>
        <el-divider content-position="left">title="内容文字"</el-divider>
        <j-label title="内容文字">
            包含内容，可以是文本，或块级元素
        </j-label>
        <el-divider content-position="left">内容为空</el-divider>
        <j-label title="内容为空"></j-label>
        <el-divider content-position="left">内容为图片</el-divider>
        <j-label title="内容图片">
            <img height="100px" src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" alt="test">
        </j-label>
        <el-divider content-position="left">内容为超长文字</el-divider>
        <div style="width: 400px">
            <j-label title="标题超长文字">
                超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字
            </j-label>
        </div>
        <el-divider content-position="left">inline 行内模式，按多个label宽度平均分多余部分自动换行</el-divider>
        <div style="width: 800px;">
            <j-label title="行内模式1" inline>行内模式行内模式行内模式行内模式</j-label><j-label title="行内模式2" inline>行内模式行内模式行内模式行内模式</j-label>
            <j-label title="行内模式1" inline>行内模式行内模式行内模式行内模式</j-label><j-label title="行内模式2" inline>行内模式行内模式行内模式行内模式</j-label>
        </div>
        <el-divider content-position="left">label对其方式 align(left, center, right) :labelWidth="200"</el-divider>
        <div style="width: 400px;">
            <j-label title="左对齐" :labelWidth="200" align="left">left</j-label>
            <j-label title="中间对齐" :labelWidth="200" align="center">center</j-label>
            <j-label title="右对齐" :labelWidth="200" align="right">right</j-label>
        </div>
    </el-card>
</template>

<script>
    import JLabel from "./JLabel";
    export default {
        components: {
            JLabel
        },
        data() {
            return {

            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
